export type DenyList = Record<string, string[]>;

export const denyListToLowerCase = (denyList: DenyList) => {
  return Object.keys(denyList).reduce((destination, key) => {
    // @ts-expect-error TODO Fix
    destination[key.toLowerCase()] = denyList[key].map((g) => g.toLowerCase());
    return destination;
  }, {});
};

export const isDenyDevice = <
  T extends {
    deviceManufacturer?: string;
    deviceModel?: string;
  },
>(
  deviceAttributes: T,
  denyList: DenyList,
) => {
  // @ts-expect-error TODO Fix
  const denyModelList = denyList[deviceAttributes.deviceManufacturer.toLowerCase()];
  if (Array.isArray(denyModelList)) {
    if (!denyModelList.length) return true;
    // @ts-expect-error TODO Fix
    return denyModelList.includes(deviceAttributes.deviceModel.toLowerCase());
  }
  return false;
};
